import { Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { shareReplayComponentConfig } from '../constants';

// @ts-ignore
@Component({
  template: '',
  standalone: false,
})
export abstract class NetworkActiveComponent {
  protected networkActive$$ = new BehaviorSubject<boolean>(false);
  public networkActive$: Observable<boolean> = this.networkActive$$.pipe(shareReplay(shareReplayComponentConfig));

  public get isActive() {
    return this.networkActive$$.value;
  }

  public set isActive(active: boolean) {
    this.networkActive$$.next(active);
  }
}
